import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=55996c35&scoped=true&"
import script from "./CurrencySelect.vue?vue&type=script&lang=js&"
export * from "./CurrencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55996c35",
  null
  
)

export default component.exports